import { render, staticRenderFns } from "./YouTubeUpdateCommentStatus.vue?vue&type=template&id=0de19cb1&scoped=true"
import script from "./YouTubeUpdateCommentStatus.vue?vue&type=script&lang=js"
export * from "./YouTubeUpdateCommentStatus.vue?vue&type=script&lang=js"
import style0 from "./YouTubeUpdateCommentStatus.vue?vue&type=style&index=0&id=0de19cb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de19cb1",
  null
  
)

export default component.exports